import { useEffect, useState } from "react";
import { Receipt, DownloadSimple } from "@phosphor-icons/react";
import api from "@/lib/api";
import { useI18n, fmtDate as fmt } from "@/i18n/I18nContext";
import { toast } from "sonner";


export default function Receipts({ reloadKey }) {
  const { t, lang } = useI18n();
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");
  const fmtDate = (iso) => fmt(iso, lang) || "—";

  useEffect(() => { api.get("/billing/receipts").then(({ data }) => setRows(data)).catch(() => setRows([])); }, [reloadKey]);

  const download = async (r) => {
    setBusy(r.id);
    try {
      const { data } = await api.get(`/billing/receipts/${r.id}/pdf?lang=${lang}`, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url; a.download = `${r.number}.pdf`; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error(t.billing.downloadFailed); }
    setBusy("");
  };

  return (
    <div className="bg-white rounded-xl border border-[#E5E2DC] p-6" data-testid="receipts-section">
      <h2 className="font-heading text-xl font-medium mb-4 flex items-center gap-2"><Receipt size={20} weight="duotone" /> {t.billing.history}</h2>
      {rows === null ? <div className="h-10" /> : rows.length === 0 ? (
        <p data-testid="receipts-empty" className="text-sm text-[#6B6A67]">{t.billing.noReceipts}</p>
      ) : (
        <div className="divide-y divide-[#E5E2DC]">
          {rows.map((r) => (
            <div key={r.id} data-testid={`receipt-${r.id}`} className="py-3 flex flex-wrap items-center justify-between gap-3 text-sm">
              <div>
                <div className="font-semibold">{r.number}</div>
                <div className="text-xs text-[#6B6A67]">{fmtDate(r.paid_at)} · BellaOS <span className="capitalize">{r.plan}</span>{r.period_end ? ` · ${fmtDate(r.period_start)} – ${fmtDate(r.period_end)}` : ""}</div>
              </div>
              <div className="flex items-center gap-4">
                <span className="font-heading font-semibold">{r.currency === "CRC" ? "₡" : `${r.currency} `}{Number(r.amount).toLocaleString()}</span>
                <button data-testid={`receipt-download-${r.id}`} onClick={() => download(r)} disabled={busy === r.id}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-[#E5E2DC] hover:bg-[#2C3E35] hover:text-white transition-colors text-xs font-semibold disabled:opacity-50">
                  <DownloadSimple size={14} /> PDF
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
